export enum MilestoneTypes {
  No_Milestone = 0,
  Bronze = 1,
  Silver = 2,
  Gold = 3,
}
